/**
 * FAQ Sub-Accordion - Final Solution
 * Works with native browser details/summary behavior
 * Prevents nested clicks from affecting parent accordions
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Use event delegation to capture all clicks on summary elements
  document.addEventListener('click', function(event) {
    
    // Check if the clicked element is a summary inside a nested FAQ
    const summary = event.target.closest('summary');
    if (!summary) return;
    
    // Check if this summary is inside a nested FAQ accordion
    const isNestedFAQ = summary.closest('.faq-nested-accordion');
    if (!isNestedFAQ) return;
    
    // Stop the event from bubbling up to parent elements
    event.stopPropagation();
    
    // Get the details element for this summary
    const details = summary.closest('details');
    if (!details) return;
    
    // Handle the one-at-a-time behavior
    const container = summary.closest('.faq-nested-accordion');
    const allFAQDetails = container.querySelectorAll('details');
    
    // If we're opening this one, close the others
    if (!details.open) {
      allFAQDetails.forEach(function(otherDetails) {
        if (otherDetails !== details) {
          otherDetails.open = false;
        }
      });
    }
    
    // Let the browser handle the toggle for this details element
    // (We don't prevent default, so normal details behavior works)
    
  }, true); // Use capture phase to catch events before they bubble
  
});